import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QualityInspectComponent } from './quality-inspect.component';
import { CoreModule } from '@dm/core';

@NgModule({
    declarations: [QualityInspectComponent],
    imports: [
        CommonModule,
        CoreModule,
    ],
    exports: [QualityInspectComponent],
})

export class QualityInspectModule { }
